import { createContext } from 'react';

// Contexto para manejar los datos de facturación de forma desacoplada del mainReducer
export const BillingFormContext = createContext({
    // Datos del formulario de facturación
    formValues: {
        country: '',
        name: '',
        vat_number: '',
        address: '',
        town: '',
        province: '',
        zip_code: ''
    },
    // Si el usuario quiere factura
    wantsAnInvoice: false,
    // Función para cambiar wantsAnInvoice
    setWantsAnInvoice: () => {},
    // Función para ejecutar submit y validar
    handleSubmit: null,
    // Función para generar presupuesto con validación
    validateAndGenerateBudget: null,
    // Si el formulario tiene errores
    hasErrors: false
});
